


























































import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      mediaList: false,
      hierarchyList: false,
      mainmenuitem: "",
    };
  },

  watch: {
    $route: {
      handler: function (route) {
        this.$nextTick(() => {
          this.handleSubMenuSelection(route);
        });
      },
      deep: true,
      immediate: true,
    },
    "$store.state.slideMenuOpen": function () {
      if (!this.$store.state.slideMenuOpen) {
        this.mediaList = false;
        this.hierarchyList = false;
      }
    },
  },

  methods: {
    handleSubMenuSelection(menuitem: any): void {
      this.mainmenuitem = "";
      this.$store.state.slideMenuOpen = false;
      switch (menuitem.name) {
        case "photos":
        case "videos":
          this.mainmenuitem = "media";
          break;
        case "adminPanel":
        case "worldHeirarchy":
        case "nationalHeirarchy":
        case "nationalRepresentatives":
          this.mainmenuitem = "hierarchy";
          break;
        default:
          this.mainmenuitem = menuitem.name ? menuitem.name : "";
          break;
      }
    },
    handleSubMenuOpen(menuitem: string = ""): void {
      switch (menuitem) {
        case "hierarchy":
          this.hierarchyList =
            this.$store.state.slideMenuOpen && !this.hierarchyList
              ? true
              : false;
          break;
        case "media":
          this.mediaList =
            this.$store.state.slideMenuOpen && !this.mediaList ? true : false;
          break;
        default:
          this.mediaList = false;
          this.hierarchyList = false;
          break;
      }
    },
  },
});
